export const ShowFeatures = ({width}) => {
    return (
        <div className="content__body__element">
            <div className="content__body__features">
                <div className="content__body__features__element1 element">
                    <div className="content__body__features__title title1">Entdecke Angebote in deiner Umgebung
                    </div>
                    <div className="content__body__features__detail block1">
                        Finde Händler mit aktuellen Angeboten in deiner Nähe! Nutze dabei die Filteraktion, um die
                        Suche auf deinen Bedarf anzupassen.
                    </div>
                </div>

                <div className="content__body__features__element2 element">
                    <div className="content__body__features__title title2">Neue Läden kennenlernen</div>
                    <div className="content__body__features__detail block2">
                        Finde heraus wer in deiner Nähe alles an Loremio teilnimmt und nehme an ihren
                        Angebotsaktionen teil.
                    </div>
                </div>

                <div className="content__body__features__element1 element">
                    <div className="content__body__features__title title1">Folge den Lieblingsläden</div>
                    <div className="content__body__features__detail block1">
                        Ob dein Friseur, dein Buchladen oder dein Lieblingsrestaurant - Koppel dich mit ihnen und
                        erhalte eine Benachrichtigung sobald sie eine neue Aktion am start haben.
                    </div>
                </div>

                <div className="content__body__features__element2 element">
                    <div className="content__body__features__title title2">Keine Anmeldung nötig</div>
                    <div className="content__body__features__detail block2">
                        Du kannst dir zwar bei Loremio ein Konto erstellen, doch zum nutzen der App samt seinen
                        gesamten Funktionalitäten ist dies nicht zwingend nötig.
                    </div>
                </div>

                <div className="content__body__features__element1 element">
                    <div className="content__body__features__title title1">Registriere dein Unternehmen bei Loremio
                    </div>
                    <div className="content__body__features__detail block1">
                        Mit nur wenigen Schritten kannst du dein Unternehmen in der Loremio-Plattform
                        anmelden und direkt damit loslegen, einen Draht zu deiner Kundschaft aufzubauen und Angebote
                        in der Umgebung zu werben (bis zu 100 KM).
                    </div>
                </div>

                {/**<div className="content__body__features__element4">
                 <font style={{ color: '#ffad4e', fontWeight: 'bold' }}>-</font> Nutzer | <font
                 style={{ color: '#ffad4e', fontWeight: 'bold' }}>-</font> Händler | <font
                 style={{ color: '#ffad4e', fontWeight: 'bold' }}>-</font> neue Angebote pro Minute | <font
                 style={{ color: '#ffad4e', fontWeight: 'bold' }}>-</font> erstellte Angebote
                 </div>**/}
            </div>
        </div>
    )
}